import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import CrossIcon from '../../../icons/Cross'
import './search-bar.scss'

class SearchBar extends Component {
  componentDidMount = () => this.field.focus()

  render() {
    const {
      title, onCloseBar, onChange, onKeyPress, holdKeyword
    } = this.props
    return (
      <div className="search-bar">
        <div className="search-bar__header">
          <div className="search-bar__header-title">
            {title}
          </div>
          <CrossIcon className="search-bar__header-clear" onClick={onCloseBar} />
        </div>
        <div className="search-bar__input">
          <input
            className="search-bar__input-field"
            type="text"
            name="keyword"
            onChange={onChange}
            defaultValue={holdKeyword}
            onKeyPress={onKeyPress}
            ref={field => this.field = field}
            autoComplete="off"
          />
        </div>
        <div className="search-bar__line" />
      </div>
    )
  }
}

SearchBar.propTypes = {
  title: PropTypes.string.isRequired,
  onCloseBar: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  holdKeyword: PropTypes.string,
}

const mapStateToProps = ({
  main: {
    holdKeyword,
  },
}) => ({
  holdKeyword,
})

export default connect(mapStateToProps)(SearchBar)
